module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/thread-loader/dist/cjs.js??ref--8-0!../../../node_modules/babel-loader/lib/index.js??ref--8-1!./CancelPage.jsx"));
	}, "CancelPage");
}